<div class="content">
  <div class="row items-push">
    <div class="col-sm-12 text-left">
      <ol class="breadcrumb push-10-t">
        <li><a [routerLink]="['/']">Inicio</a></li>
        <li><span class="link-effect">PASST</span></li>
        <li><span class="link-effect">Seguimiento</span></li>
      </ol>
    </div>
  </div>
</div>

<div class="content">
  <div class="block">
    <div class="block-header">
      <h3 class="block-title">Seguimiento PASST</h3>
    </div>


    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <label class="col-md-2 control-label">Compañía:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Seleccione: </mat-label>
              <mat-select matSelect [(ngModel)]="model.idCompania" [disabled]="listaCompanias.length == 1"
                (selectionChange)="companiaChanged()">
                <mat-option *ngFor="let company of listaCompanias" [value]="company.idCompania">
                  {{ company.nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <label class="col-md-2 control-label">Sede (*):</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>
                Seleccione
              </mat-label>
              <mat-select matSelect [(ngModel)]="model.idSede">
                <mat-option *ngFor="let sede of listaSedes; index as i;"
                  [value]='sede.idSede'>{{sede.nombre}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-2 control-label">Año:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>
                Seleccione
              </mat-label>
              <mat-select matSelect [(ngModel)]="model.anio">
                <mat-option *ngFor="let item of listaAnios; index as i;" [value]='item'>{{item}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="form-horizontal">
          <div class="form-group">
            <div class="col-sm-8 text-left">
              <!-- <a class="btn btn-new" mat-raised-button><mat-icon>description</mat-icon> Nueva Actividad</a>    -->
              <button type="submit" class="btn btn-celeste" *ngIf="idPasst != 0 && puedeSolicitar" mat-raised-button
                (click)="openDialogSolicitarEdicion()"><mat-icon>timer</mat-icon> Solicitar Modificación</button>
              <a class="btn btn-naranja" mat-raised-button *ngIf="idPasst != 0"
                [routerLink]="['/passt', idPasst, 'rotulo']"><mat-icon>description</mat-icon> Editar Rotulo</a>
              <button type="submit" class="btn btn-celeste" *ngIf="idPasst != 0" mat-raised-button
                (click)="exportarPasst()"><mat-icon>table_chart</mat-icon> Exportar</button>
              <button type="submit" class="btn btn-celeste" *ngIf="idPasst != 0" mat-raised-button
                (click)="openDialogLogPasst()"><mat-icon>message</mat-icon> Historial Comentarios</button>
            </div>
            <div class="col-sm-4 text-right">
              <a class="btn btn-cyan" mat-raised-button (click)="search()"><mat-icon>search</mat-icon> Buscar</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="block-content">
      <div class="form-horizontal">
        <mat-divider class="engie-divider"></mat-divider>
      </div>
      <mat-tab-group>
        <mat-tab label="Resumen">

          <div class="block-content">
            <div class="table-responsive">
              <table mat-table [dataSource]="listaResumen" multiTemplateDataRows
                class="table table-striped table-vcenter">

                <ng-container matColumnDef="resumen">
                  <th mat-header-cell *matHeaderCellDef>Concepto</th>
                  <td mat-cell *matCellDef="let element" class="centre">{{ element.concepto}}</td>
                </ng-container>

                <ng-container matColumnDef="enero">
                  <th mat-header-cell *matHeaderCellDef>Ene</th>
                  <td mat-cell *matCellDef="let element" class="centre">{{ element.enero }}</td>
                </ng-container>
                <ng-container matColumnDef="febrero">
                  <th mat-header-cell *matHeaderCellDef>Feb</th>
                  <td mat-cell *matCellDef="let element" class="centre">{{ element.febrero }}</td>
                </ng-container>
                <ng-container matColumnDef="marzo">
                  <th mat-header-cell *matHeaderCellDef>Mar</th>
                  <td mat-cell *matCellDef="let element" class="centre">{{ element.marzo }}</td>
                </ng-container>
                <ng-container matColumnDef="abril">
                  <th mat-header-cell *matHeaderCellDef>Abr</th>
                  <td mat-cell *matCellDef="let element" class="centre">{{ element.abril }}</td>
                </ng-container>
                <ng-container matColumnDef="mayo">
                  <th mat-header-cell *matHeaderCellDef>May</th>
                  <td mat-cell *matCellDef="let element" class="centre">{{ element.mayo }}</td>
                </ng-container>
                <ng-container matColumnDef="junio">
                  <th mat-header-cell *matHeaderCellDef>Jun</th>
                  <td mat-cell *matCellDef="let element" class="centre">{{ element.junio }}</td>
                </ng-container>
                <ng-container matColumnDef="julio">
                  <th mat-header-cell *matHeaderCellDef>Jul</th>
                  <td mat-cell *matCellDef="let element" class="centre">{{ element.julio }}</td>
                </ng-container>
                <ng-container matColumnDef="agosto">
                  <th mat-header-cell *matHeaderCellDef>Ago</th>
                  <td mat-cell *matCellDef="let element" class="centre">{{ element.agosto }}</td>
                </ng-container>
                <ng-container matColumnDef="setiembre">
                  <th mat-header-cell *matHeaderCellDef>Set</th>
                  <td mat-cell *matCellDef="let element" class="centre">{{ element.setiembre }}</td>
                </ng-container>
                <ng-container matColumnDef="octubre">
                  <th mat-header-cell *matHeaderCellDef>Oct</th>
                  <td mat-cell *matCellDef="let element" class="centre">{{ element.octubre }}</td>
                </ng-container>
                <ng-container matColumnDef="noviembre">
                  <th mat-header-cell *matHeaderCellDef>Nov</th>
                  <td mat-cell *matCellDef="let element" class="centre">{{ element.noviembre }}</td>
                </ng-container>
                <ng-container matColumnDef="diciembre">
                  <th mat-header-cell *matHeaderCellDef>Dic</th>
                  <td mat-cell *matCellDef="let element" class="centre">{{ element.diciembre }}</td>
                </ng-container>
                <ng-container matColumnDef="total">
                  <th mat-header-cell *matHeaderCellDef>Total</th>
                  <td mat-cell *matCellDef="let element" class="centre">{{ element.total }}</td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedColumnsResumen"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsResumen"></tr>

              </table>

              <!-- <mat-paginator #paginator [length]="resultsLength" [pageSize]="30" 
                    (page)="getPaginatorData($event)"
                    [pageSizeOptions]="[30, 50, 100]"></mat-paginator> -->
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
    <div class="block-content">
      <div class="form-horizontal">
        <mat-divider class="engie-divider"></mat-divider>
        <div class="form-group">
          <!-- <div class="col-sm-3 text-left"><label class="control-label">Avance de Información Completada:</label></div>
        <div class="col-sm-3 text-left"><mat-progress-bar [value]="30" [bufferValue]="30"></mat-progress-bar>  </div>
        <div class="col-sm-4 text-left"><label class="control-label">{{30}} % (12 de 30)</label></div> -->
          <div class="col-sm-12 text-right"><label class="control-label">Mes a declarar: {{currentCalendar.nombreMes}} -
              {{currentCalendar.anio}}</label></div>
        </div>
      </div>
      <mat-tab-group>
        <mat-tab label="Detalle">
          <mat-tree [dataSource]="dataSourceTree" [treeControl]="treeControl">
            <!-- This is the tree node template for leaf nodes -->
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
              <!-- use a disabled button to provide padding for tree leaf -->
              <button mat-icon-button disabled></button>
              <!-- {{node.name}} -->
              <div class="form-horizontal table-intree ficha-passt">
                <div class="table-responsive">
                  <table mat-table [dataSource]="node.data" multiTemplateDataRows
                    class="table table-striped table-vcenter">
                    <ng-container matColumnDef="actividad">
                      <th mat-header-cell *matHeaderCellDef>Actividad</th>
                      <td mat-cell *matCellDef="let element">
                        <div class="text-red" *ngIf="!esAdminSSO && element.editable">{{ element.actividad}} - Editable
                        </div>
                        <div *ngIf="esAdminSSO || !element.editable">{{ element.actividad}}</div>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="enero">
                      <th mat-header-cell *matHeaderCellDef>Ene</th>
                      <td mat-cell *matCellDef="let element" class="centre cell-passt">
                        <ng-container>
                          <div class="multi-line">
                            <div class="passt-program" *ngIf="!passtEditable || mesPasstEditable > 1"
                              [ngClass]="[element.eneroProgramado == 'P' ? 'backcolor-yellow' : 'not-backcolor', element.eneroProgramado == 'R' ? 'backcolor-red' : 'not-backcolor']">
                              {{ element.eneroProgramado }}</div>
                            <div class="passt-program" *ngIf="passtEditable && mesPasstEditable <=1 ">
                              <mat-form-field appearance="outline">
                                <mat-select matSelect [(ngModel)]="element.eneroProgramado">
                                  <mat-option></mat-option>
                                  <mat-option *ngFor="let estado of listaEstadosProgramacion; index as i;"
                                    [value]='estado.valor'>{{estado.valor}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div class="passt-exec"
                              *ngIf="!element.eneroEditable && !esAdminSSO && !element.editable && (!passtEditable || mesPasstEditable > 1)"
                              [ngClass]="[element.eneroEjecutado == 'E' ? 'backcolor-red' : 'not-backcolor', element.eneroEjecutado == 'R' ? 'backcolor-green' : 'not-backcolor', element.eneroEjecutado == 'C' ? 'backcolor-skyblue' : 'not-backcolor']">
                              {{ element.eneroEjecutado }}</div>
                            <div class="passt-exec"
                              *ngIf="element.eneroEditable || esAdminSSO || element.editable || (passtEditable && mesPasstEditable <=1)">
                              <mat-form-field appearance="outline">
                                <mat-select matSelect [(ngModel)]="element.idEstadoEnero"
                                  (selectionChange)="stateChanged($event, element, 1)">
                                  <mat-option></mat-option>
                                  <mat-option *ngFor="let estado of listaEstados; index as i;"
                                    [value]='estado.idParametroDetalle'>{{estado.valor}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>

                        </ng-container>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="febrero">
                      <th mat-header-cell *matHeaderCellDef>Feb</th>
                      <td mat-cell *matCellDef="let element" class="centre cell-passt">
                        <ng-container>
                          <div class="multi-line">
                            <div class="passt-program" *ngIf="!passtEditable || mesPasstEditable > 2"
                              [ngClass]="[element.febreroProgramado == 'P' ? 'backcolor-yellow' : 'not-backcolor', element.febreroProgramado == 'R' ? 'backcolor-red' : 'not-backcolor']">
                              {{ element.febreroProgramado }}</div>
                            <div class="passt-program" *ngIf="passtEditable && mesPasstEditable <= 2 ">
                              <mat-form-field appearance="outline">
                                <mat-select matSelect [(ngModel)]="element.febreroProgramado">
                                  <mat-option></mat-option>
                                  <mat-option *ngFor="let estado of listaEstadosProgramacion; index as i;"
                                    [value]='estado.valor'>{{estado.valor}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div class="passt-exec"
                              *ngIf="!element.febreroEditable && !esAdminSSO && !element.editable && (!passtEditable || mesPasstEditable > 2)"
                              [ngClass]="[element.febreroEjecutado == 'E' ? 'backcolor-red' : 'not-backcolor', element.febreroEjecutado == 'R' ? 'backcolor-green' : 'not-backcolor', element.febreroEjecutado == 'C' ? 'backcolor-skyblue' : 'not-backcolor']">
                              {{ element.febreroEjecutado }}</div>
                            <div class="passt-exec"
                              *ngIf="element.febreroEditable || esAdminSSO || element.editable || (passtEditable && mesPasstEditable <=2)">
                              <mat-form-field appearance="outline">
                                <mat-select matSelect [(ngModel)]="element.idEstadoFebrero"
                                  (selectionChange)="stateChanged($event, element, 2)">
                                  <mat-option></mat-option>
                                  <mat-option *ngFor="let estado of listaEstados; index as i;"
                                    [value]='estado.idParametroDetalle'>{{estado.valor}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
                        </ng-container>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="marzo">
                      <th mat-header-cell *matHeaderCellDef>Mar</th>
                      <td mat-cell *matCellDef="let element" class="centre cell-passt">
                        <ng-container>
                          <div class="multi-line">
                            <div class="passt-program" *ngIf="!passtEditable || mesPasstEditable > 3"
                              [ngClass]="[element.marzoProgramado == 'P' ? 'backcolor-yellow' : 'not-backcolor', element.marzoProgramado == 'R' ? 'backcolor-red' : 'not-backcolor']">
                              {{ element.marzoProgramado }}</div>
                            <div class="passt-program" *ngIf="passtEditable && mesPasstEditable <=3 ">
                              <mat-form-field appearance="outline">
                                <mat-select matSelect [(ngModel)]="element.marzoProgramado">
                                  <mat-option></mat-option>
                                  <mat-option *ngFor="let estado of listaEstadosProgramacion; index as i;"
                                    [value]='estado.valor'>{{estado.valor}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div class="passt-exec"
                              *ngIf="!element.marzoEditable && !esAdminSSO && !element.editable && (!passtEditable || mesPasstEditable > 3)"
                              [ngClass]="[element.marzoEjecutado == 'E' ? 'backcolor-red' : 'not-backcolor', element.marzoEjecutado == 'R' ? 'backcolor-green' : 'not-backcolor', element.marzoEjecutado == 'C' ? 'backcolor-skyblue' : 'not-backcolor']">
                              {{ element.marzoEjecutado }}</div>
                            <div class="passt-exec"
                              *ngIf="element.marzoEditable || esAdminSSO || element.editable || (passtEditable && mesPasstEditable <=3)">
                              <mat-form-field appearance="outline">
                                <mat-select matSelect [(ngModel)]="element.idEstadoMarzo"
                                  (selectionChange)="stateChanged($event, element, 3)">
                                  <mat-option></mat-option>
                                  <mat-option *ngFor="let estado of listaEstados; index as i;"
                                    [value]='estado.idParametroDetalle'>{{estado.valor}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
                        </ng-container>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="abril">
                      <th mat-header-cell *matHeaderCellDef>Abr</th>
                      <td mat-cell *matCellDef="let element" class="centre cell-passt">
                        <ng-container>
                          <div class="multi-line">
                            <div class="passt-program" *ngIf="!passtEditable || mesPasstEditable > 4"
                              [ngClass]="[element.abrilProgramado == 'P' ? 'backcolor-yellow' : 'not-backcolor', element.abrilProgramado == 'R' ? 'backcolor-red' : 'not-backcolor']">
                              {{ element.abrilProgramado }}</div>
                            <div class="passt-program" *ngIf="passtEditable && mesPasstEditable <= 4 ">
                              <mat-form-field appearance="outline">
                                <mat-select matSelect [(ngModel)]="element.abrilProgramado">
                                  <mat-option></mat-option>
                                  <mat-option *ngFor="let estado of listaEstadosProgramacion; index as i;"
                                    [value]='estado.valor'>{{estado.valor}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div class="passt-exec"
                              *ngIf="!element.abrilEditable && !esAdminSSO && !element.editable && (!passtEditable || mesPasstEditable > 4)"
                              [ngClass]="[element.abrilEjecutado == 'E' ? 'backcolor-red' : 'not-backcolor', element.abrilEjecutado == 'R' ? 'backcolor-green' : 'not-backcolor', element.abrilEjecutado == 'C' ? 'backcolor-skyblue' : 'not-backcolor']">
                              {{ element.abrilEjecutado }}</div>
                            <div class="passt-exec"
                              *ngIf="element.abrilEditable || esAdminSSO || element.editable || (passtEditable && mesPasstEditable <=4)">
                              <mat-form-field appearance="outline">
                                <mat-select matSelect [(ngModel)]="element.idEstadoAbril"
                                  (selectionChange)="stateChanged($event, element, 4)">
                                  <mat-option></mat-option>
                                  <mat-option *ngFor="let estado of listaEstados; index as i;"
                                    [value]='estado.idParametroDetalle'>{{estado.valor}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
                        </ng-container>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="mayo">
                      <th mat-header-cell *matHeaderCellDef>May</th>
                      <td mat-cell *matCellDef="let element" class="centre cell-passt">
                        <ng-container>
                          <div class="multi-line">
                            <div class="passt-program" *ngIf="!passtEditable || mesPasstEditable > 5"
                              [ngClass]="[element.mayoProgramado == 'P' ? 'backcolor-yellow' : 'not-backcolor', element.mayoProgramado == 'R' ? 'backcolor-red' : 'not-backcolor']">
                              {{ element.mayoProgramado }}</div>
                            <div class="passt-program" *ngIf="passtEditable && mesPasstEditable <= 5 ">
                              <mat-form-field appearance="outline">
                                <mat-select matSelect [(ngModel)]="element.mayoProgramado">
                                  <mat-option></mat-option>
                                  <mat-option *ngFor="let estado of listaEstadosProgramacion; index as i;"
                                    [value]='estado.valor'>{{estado.valor}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div class="passt-exec"
                              *ngIf="!element.mayoEditable && !esAdminSSO && !element.editable && (!passtEditable || mesPasstEditable > 5)"
                              [ngClass]="[element.mayoEjecutado == 'E' ? 'backcolor-red' : 'not-backcolor', element.mayoEjecutado == 'R' ? 'backcolor-green' : 'not-backcolor', element.mayoEjecutado == 'C' ? 'backcolor-skyblue' : 'not-backcolor']">
                              {{ element.mayoEjecutado }}</div>
                            <div class="passt-exec"
                              *ngIf="element.mayoEditable || esAdminSSO || element.editable || (passtEditable && mesPasstEditable <=5)">
                              <mat-form-field appearance="outline">
                                <mat-select matSelect [(ngModel)]="element.idEstadoMayo"
                                  (selectionChange)="stateChanged($event, element, 5)">
                                  <mat-option></mat-option>
                                  <mat-option *ngFor="let estado of listaEstados; index as i;"
                                    [value]='estado.idParametroDetalle'>{{estado.valor}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
                        </ng-container>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="junio">
                      <th mat-header-cell *matHeaderCellDef>Jun</th>
                      <td mat-cell *matCellDef="let element" class="centre cell-passt">
                        <ng-container>
                          <div class="multi-line">
                            <div class="passt-program" *ngIf="!passtEditable || mesPasstEditable > 6"
                              [ngClass]="[element.junioProgramado == 'P' ? 'backcolor-yellow' : 'not-backcolor', element.junioProgramado == 'R' ? 'backcolor-red' : 'not-backcolor']">
                              {{ element.junioProgramado }}</div>
                            <div class="passt-program" *ngIf="passtEditable && mesPasstEditable <= 6 ">
                              <mat-form-field appearance="outline">
                                <mat-select matSelect [(ngModel)]="element.junioProgramado">
                                  <mat-option></mat-option>
                                  <mat-option *ngFor="let estado of listaEstadosProgramacion; index as i;"
                                    [value]='estado.valor'>{{estado.valor}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div class="passt-exec"
                              *ngIf="!element.junioEditable && !esAdminSSO && !element.editable && (!passtEditable || mesPasstEditable > 6)"
                              [ngClass]="[element.junioEjecutado == 'E' ? 'backcolor-red' : 'not-backcolor', element.junioEjecutado == 'R' ? 'backcolor-green' : 'not-backcolor', element.junioEjecutado == 'C' ? 'backcolor-skyblue' : 'not-backcolor']">
                              {{ element.junioEjecutado }}</div>
                            <div class="passt-exec"
                              *ngIf="element.junioEditable || esAdminSSO || element.editable || (passtEditable && mesPasstEditable <=6)">
                              <mat-form-field appearance="outline">
                                <mat-select matSelect [(ngModel)]="element.idEstadoJunio"
                                  (selectionChange)="stateChanged($event, element, 6)">
                                  <mat-option></mat-option>
                                  <mat-option *ngFor="let estado of listaEstados; index as i;"
                                    [value]='estado.idParametroDetalle'>{{estado.valor}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
                        </ng-container>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="julio">
                      <th mat-header-cell *matHeaderCellDef>Jul</th>
                      <td mat-cell *matCellDef="let element" class="centre cell-passt">
                        <ng-container>
                          <div class="multi-line">
                            <div class="passt-program" *ngIf="!passtEditable || mesPasstEditable > 7"
                              [ngClass]="[element.julioProgramado == 'P' ? 'backcolor-yellow' : 'not-backcolor', element.julioProgramado == 'R' ? 'backcolor-red' : 'not-backcolor']">
                              {{ element.julioProgramado }}</div>
                            <div class="passt-program" *ngIf="passtEditable && mesPasstEditable <= 7 ">
                              <mat-form-field appearance="outline">
                                <mat-select matSelect [(ngModel)]="element.julioProgramado">
                                  <mat-option></mat-option>
                                  <mat-option *ngFor="let estado of listaEstadosProgramacion; index as i;"
                                    [value]='estado.valor'>{{estado.valor}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div class="passt-exec"
                              *ngIf="!element.julioEditable && !esAdminSSO && !element.editable && (!passtEditable || mesPasstEditable > 7)"
                              [ngClass]="[element.julioEjecutado == 'E' ? 'backcolor-red' : 'not-backcolor', element.julioEjecutado == 'R' ? 'backcolor-green' : 'not-backcolor', element.julioEjecutado == 'C' ? 'backcolor-skyblue' : 'not-backcolor']">
                              {{ element.julioEjecutado }}</div>
                            <div class="passt-exec"
                              *ngIf="element.julioEditable || esAdminSSO || element.editable || (passtEditable && mesPasstEditable <=7)">
                              <mat-form-field appearance="outline">
                                <mat-select matSelect [(ngModel)]="element.idEstadoJulio"
                                  (selectionChange)="stateChanged($event, element, 7)">
                                  <mat-option></mat-option>
                                  <mat-option *ngFor="let estado of listaEstados; index as i;"
                                    [value]='estado.idParametroDetalle'>{{estado.valor}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
                        </ng-container>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="agosto">
                      <th mat-header-cell *matHeaderCellDef>Ago</th>
                      <td mat-cell *matCellDef="let element" class="centre cell-passt">
                        <ng-container>
                          <div class="multi-line">
                            <div class="passt-program" *ngIf="!passtEditable || mesPasstEditable > 8"
                              [ngClass]="[element.agostoProgramado == 'P' ? 'backcolor-yellow' : 'not-backcolor', element.agostoProgramado == 'R' ? 'backcolor-red' : 'not-backcolor']">
                              {{ element.agostoProgramado }}</div>
                            <div class="passt-program" *ngIf="passtEditable && mesPasstEditable <= 8 ">
                              <mat-form-field appearance="outline">
                                <mat-select matSelect [(ngModel)]="element.agostoProgramado">
                                  <mat-option></mat-option>
                                  <mat-option *ngFor="let estado of listaEstadosProgramacion; index as i;"
                                    [value]='estado.valor'>{{estado.valor}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div class="passt-exec"
                              *ngIf="!element.agostoEditable && !esAdminSSO && !element.editable && (!passtEditable || mesPasstEditable > 8)"
                              [ngClass]="[element.agostoEjecutado == 'E' ? 'backcolor-red' : 'not-backcolor', element.agostoEjecutado == 'R' ? 'backcolor-green' : 'not-backcolor', element.agostoEjecutado == 'C' ? 'backcolor-skyblue' : 'not-backcolor']">
                              {{ element.agostoEjecutado }}</div>
                            <div class="passt-exec"
                              *ngIf="element.agostoEditable || esAdminSSO || element.editable || (passtEditable && mesPasstEditable <=8)">
                              <mat-form-field appearance="outline">
                                <mat-select matSelect [(ngModel)]="element.idEstadoAgosto"
                                  (selectionChange)="stateChanged($event, element, 8)">
                                  <mat-option></mat-option>
                                  <mat-option *ngFor="let estado of listaEstados; index as i;"
                                    [value]='estado.idParametroDetalle'>{{estado.valor}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
                        </ng-container>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="setiembre">
                      <th mat-header-cell *matHeaderCellDef>Set</th>
                      <td mat-cell *matCellDef="let element" class="centre cell-passt">
                        <ng-container>
                          <div class="multi-line">
                            <div class="passt-program" *ngIf="!passtEditable || mesPasstEditable > 9"
                              [ngClass]="[element.setiembreProgramado == 'P' ? 'backcolor-yellow' : 'not-backcolor', element.setiembreProgramado == 'R' ? 'backcolor-red' : 'not-backcolor']">
                              {{ element.setiembreProgramado}}</div>
                            <div class="passt-program" *ngIf="passtEditable && mesPasstEditable <= 9 ">
                              <mat-form-field appearance="outline">
                                <mat-select matSelect [(ngModel)]="element.setiembreProgramado">
                                  <mat-option></mat-option>
                                  <mat-option *ngFor="let estado of listaEstadosProgramacion; index as i;"
                                    [value]='estado.valor'>{{estado.valor}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div class="passt-exec"
                              *ngIf="!element.setiembreEditable && !esAdminSSO && !element.editable && (!passtEditable || mesPasstEditable > 9)"
                              [ngClass]="[element.setiembreEjecutado == 'E' ? 'backcolor-red' : 'not-backcolor', element.setiembreEjecutado == 'R' ? 'backcolor-green' : 'not-backcolor', element.setiembreEjecutado == 'C' ? 'backcolor-skyblue' : 'not-backcolor']">
                              {{ element.setiembreEjecutado}}</div>
                            <div class="passt-exec"
                              *ngIf="element.setiembreEditable || esAdminSSO || element.editable || (passtEditable && mesPasstEditable <=9)">
                              <mat-form-field appearance="outline">
                                <mat-select matSelect [(ngModel)]="element.idEstadoSetiembre"
                                  (selectionChange)="stateChanged($event, element, 9)">
                                  <mat-option></mat-option>
                                  <mat-option *ngFor="let estado of listaEstados; index as i;"
                                    [value]='estado.idParametroDetalle'>{{estado.valor}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
                        </ng-container>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="octubre">
                      <th mat-header-cell *matHeaderCellDef>Oct</th>
                      <td mat-cell *matCellDef="let element" class="centre cell-passt">
                        <ng-container>
                          <div class="multi-line">
                            <div class="passt-program" *ngIf="!passtEditable || mesPasstEditable > 10"
                              [ngClass]="[element.octubreProgramado == 'P' ? 'backcolor-yellow' : 'not-backcolor', element.octubreProgramado == 'R' ? 'backcolor-red' : 'not-backcolor']">
                              {{ element.octubreProgramado }}</div>
                            <div class="passt-program" *ngIf="passtEditable && mesPasstEditable <= 10 ">
                              <mat-form-field appearance="outline">
                                <mat-select matSelect [(ngModel)]="element.octubreProgramado">
                                  <mat-option></mat-option>
                                  <mat-option *ngFor="let estado of listaEstadosProgramacion; index as i;"
                                    [value]='estado.valor'>{{estado.valor}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div class="passt-exec"
                              *ngIf="!element.octubreEditable && !esAdminSSO && !element.editable && (!passtEditable || mesPasstEditable > 10)"
                              [ngClass]="[element.octubreEjecutado == 'E' ? 'backcolor-red' : 'not-backcolor', element.octubreEjecutado == 'R' ? 'backcolor-green' : 'not-backcolor', element.octubreEjecutado == 'C' ? 'backcolor-skyblue' : 'not-backcolor']">
                              {{ element.octubreEjecutado }}</div>
                            <div class="passt-exec"
                              *ngIf="element.octubreEditable || esAdminSSO || element.editable || (passtEditable && mesPasstEditable <=10)">
                              <mat-form-field appearance="outline">
                                <mat-select matSelect [(ngModel)]="element.idEstadoOctubre"
                                  (selectionChange)="stateChanged($event, element, 10)">
                                  <mat-option></mat-option>
                                  <mat-option *ngFor="let estado of listaEstados; index as i;"
                                    [value]='estado.idParametroDetalle'>{{estado.valor}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
                        </ng-container>
                      </td>

                    </ng-container>
                    <ng-container matColumnDef="noviembre">
                      <th mat-header-cell *matHeaderCellDef>Nov</th>
                      <td mat-cell *matCellDef="let element" class="centre cell-passt">
                        <ng-container>
                          <div class="multi-line">
                            <div class="passt-program" *ngIf="!passtEditable || mesPasstEditable > 11"
                              [ngClass]="[element.noviembreProgramado == 'P' ? 'backcolor-yellow' : 'not-backcolor', element.noviembreProgramado == 'R' ? 'backcolor-red' : 'not-backcolor']">
                              {{ element.noviembreProgramado }}</div>
                            <div class="passt-program" *ngIf="passtEditable && mesPasstEditable <= 11 ">
                              <mat-form-field appearance="outline">
                                <mat-select matSelect [(ngModel)]="element.noviembreProgramado">
                                  <mat-option></mat-option>
                                  <mat-option *ngFor="let estado of listaEstadosProgramacion; index as i;"
                                    [value]='estado.valor'>{{estado.valor}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div class="passt-exec"
                              *ngIf="!element.noviembreEditable && !esAdminSSO && !element.editable && (!passtEditable || mesPasstEditable > 11)"
                              [ngClass]="[element.noviembreEjecutado == 'E' ? 'backcolor-red' : 'not-backcolor', element.noviembreEjecutado == 'R' ? 'backcolor-green' : 'not-backcolor', element.noviembreEjecutado == 'C' ? 'backcolor-skyblue' : 'not-backcolor']">
                              {{ element.noviembreEjecutado }}</div>
                            <div class="passt-exec"
                              *ngIf="element.noviembreEditable || esAdminSSO || element.editable || (passtEditable && mesPasstEditable <=11)">
                              <mat-form-field appearance="outline">
                                <mat-select matSelect [(ngModel)]="element.idEstadoNoviembre"
                                  (selectionChange)="stateChanged($event, element, 11)">
                                  <mat-option></mat-option>
                                  <mat-option *ngFor="let estado of listaEstados; index as i;"
                                    [value]='estado.idParametroDetalle'>{{estado.valor}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
                        </ng-container>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="diciembre">
                      <th mat-header-cell *matHeaderCellDef>Dic</th>
                      <td mat-cell *matCellDef="let element" class="centre cell-passt">
                        <ng-container>
                          <div class="multi-line">
                            <div class="passt-program" *ngIf="!passtEditable || mesPasstEditable > 12"
                              [ngClass]="[element.diciembreProgramado == 'P' ? 'backcolor-yellow' : 'not-backcolor', element.diciembreProgramado == 'R' ? 'backcolor-red' : 'not-backcolor']">
                              {{ element.diciembreProgramado }}</div>
                            <div class="passt-program" *ngIf="passtEditable && mesPasstEditable <= 12 ">
                              <mat-form-field appearance="outline">
                                <mat-select matSelect [(ngModel)]="element.diciembreProgramado">
                                  <mat-option></mat-option>
                                  <mat-option *ngFor="let estado of listaEstadosProgramacion; index as i;"
                                    [value]='estado.valor'>{{estado.valor}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div class="passt-exec"
                              *ngIf="!element.diciembreEditable && !esAdminSSO && !element.editable && (!passtEditable || mesPasstEditable > 12)"
                              [ngClass]="[element.diciembreEjecutado == 'E' ? 'backcolor-red' : 'not-backcolor', element.diciembreEjecutado == 'R' ? 'backcolor-green' : 'not-backcolor', element.diciembreEjecutado == 'C' ? 'backcolor-skyblue' : 'not-backcolor']">
                              {{ element.diciembreEjecutado }}</div>
                            <div class="passt-exec"
                              *ngIf="element.diciembreEditable || esAdminSSO || element.editable || (passtEditable && mesPasstEditable <=12)">
                              <mat-form-field appearance="outline">
                                <mat-select matSelect [(ngModel)]="element.idEstadoDiciembre"
                                  (selectionChange)="stateChanged($event, element, 12)">
                                  <mat-option></mat-option>
                                  <mat-option *ngFor="let estado of listaEstados; index as i;"
                                    [value]='estado.idParametroDetalle'>{{estado.valor}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
                        </ng-container>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="comentario">
                      <th mat-header-cell *matHeaderCellDef>Comentario</th>
                      <td mat-cell *matCellDef="let element" class="centre">
                        <mat-form-field appearance="outline">
                          <input matInput id="comentario" />
                        </mat-form-field>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="acciones">
                      <th mat-header-cell *matHeaderCellDef>Acciones</th>
                      <td mat-cell *matCellDef="let element">
                        <button mat-icon-button color="primary" aria-label="Solicitar edición de Actividad"
                          title="Solicitar edición de Actividad"
                          (click)="openDialogAmpliacion(element); $event.stopPropagation()"
                          *ngIf="!esAdminSSO && element.puedeSolicitar">
                          <mat-icon>edit</mat-icon>
                        </button>

                        <button mat-icon-button color="primary" aria-label="Edición solicitada, esperando aprobación"
                          title="Edición solicitada, esperando aprobación"
                          *ngIf="!esAdminSSO && element.puedeSolicitar && element.idEstadoModificacion == 2">
                          <mat-icon>timer</mat-icon>
                        </button>

                        <a mat-icon-button color="primary" aria-label="Eliminar actividad" title="Eliminar actividad"
                          *ngIf="(element.puedeEliminar) || esAdminSSO" (click)="eliminarActividad(element)">

                          <mat-icon>cancel_presentation</mat-icon>
                        </a>
                        <button mat-icon-button color="primary" aria-label="Ver Comentarios" title="Ver Comentarios"
                          (click)="openDialogLogActividad(element); $event.stopPropagation()">
                          <mat-icon>message</mat-icon>
                        </button>
                      </td>
                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="displayedColumnsActividades"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsActividades"></tr>

                  </table>
                </div>
              </div>
            </mat-tree-node>
            <!-- This is the tree node template for expandable nodes -->
            <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
              <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
                <mat-icon class="mat-icon-rtl-mirror">
                  {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
              </button>
              {{node.name}}
            </mat-tree-node>
          </mat-tree>
          <div class="block-content">
            <mat-divider class="engie-divider"></mat-divider>
          </div>
          <div class="form-group">
            <label class="col-md-1 control-label">Comentarios:</label>
            <div class="col-md-11">
              <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>Comentarios:</mat-label>
                <textarea matInput placeholder="Comentarios" [(ngModel)]="comentarioPasst" rows="5" name="Comentarios"
                  [maxlength]="2000"></textarea>
              </mat-form-field>

            </div>
          </div>
          <div class="form-group">
            <div class="col-sm-12 text-right">
              <button type="submit" class="btn btn-naranja" (click)="registrar()" mat-raised-button>Guardar</button>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>



  </div>
</div>